var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"countries-flag",attrs:{"src":_vm.flagUrl,"width":"26"},on:{"error":_vm.onImgError}})
}
var staticRenderFns = []

export { render, staticRenderFns }